export default {
    green: '#004857',
    greenLight: '#489EAC',
    greenLight2: '#d9e0e6',
    orange: '#FF5C00',
    white: '#FFFFFF',
    purple: '#7E3F98',
    greyLight: '#F5F5F5',
    red: 'red',
    black: 'black',
    yellow: '#F9B92C'
};
